export default __webpack_public_path__ + "static/media/color-i.436c88b3.webp";